import { Model } from "./Model";

export interface Team extends Model {
	teamName: string;
	teamNameShort: string;
	badgeUrl: string;
}

export class Team implements Team {

	constructor(data?: Partial<Team>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}